import { useQuery } from "react-query";
import { formatCurrency } from "../../helpers/general";
import { useCookie } from "../../hooks/useCookie";
import apiService from "../../service/apiService";
import { CSpinner } from "@coreui/react";
import MoneyIcon from "../../components/icons/taxiStatsIcons/MoneyIcon";
import PercentIcon from "../../components/icons/taxiStatsIcons/PercentIcon";
import WalletIcon from "../../components/icons/taxiStatsIcons/WalletIcon";

export default function PlaceManagerPercentage() {
  const { token } = useCookie("vToken");

  const fetchCommissionInfo = async (token: string) => {
    const endpoint = `booking/place-manager/commission-info`;
    return apiService.MakeGetRequest(endpoint, token);
  };
  const queryKey = ["bookig/placeManager/getCommissionInfo", token];
  const { data, isLoading } = useQuery<
    any,
    any,
    PlaceManagerBookingCommissionInfo,
    any
  >(queryKey, (query) => fetchCommissionInfo(query.queryKey[1]), {
    keepPreviousData: true,
  });

  if (isLoading) {
    return (
      <section>
        <h5 className="fs-4 fw-bold mb-2">Totale</h5>
        <div className="pt-4">
          <CSpinner color="danger" />
        </div>
      </section>
    );
  }

  return (
    <section>
      <h5 className="fs-4 fw-bold mb-2">Total</h5>
      <div className="pt-4 row">
        <CardStatistics
          title="Revenu"
          total={data?.total?.amount ?? 0}
          icon={
            (
              <MoneyIcon width="48" height="48" className="text-danger" />
            ) as React.ReactNode
          }
          borderColor="border-danger"
          iconBgColor="bg-danger"
        />
        <CardStatistics
          title={`Commission`}
          total={data?.total?.commission ?? 0}
          icon={
            (
              <PercentIcon width="48" height="48" className="text-primary" />
            ) as React.ReactNode
          }
          borderColor="border-primary"
          iconBgColor="bg-primary"
        />
      </div>
      <h5 className="fs-4 fw-bold mb-2 mt-3">En attente de paiement</h5>
      <div className="pt-4 row">
        <CardStatistics
          title="Revenu"
          total={data?.pending?.amount ?? 0}
          icon={
            (
              <MoneyIcon width="48" height="48" className="text-danger" />
            ) as React.ReactNode
          }
          borderColor="border-danger"
          iconBgColor="bg-danger"
        />
        <CardStatistics
          title={`Commission`}
          total={data?.pending?.commission ?? 0}
          icon={
            (
              <PercentIcon width="48" height="48" className="text-primary" />
            ) as React.ReactNode
          }
          borderColor="border-primary"
          iconBgColor="bg-primary"
        />
        <CardStatistics
          title="À payer"
          total={data?.pending?.toPay ?? 0}
          icon={
            (
              <WalletIcon width="48" height="48" className="text-success" />
            ) as React.ReactNode
          }
          borderColor="border-success"
          iconBgColor="bg-success"
        />
      </div>
    </section>
  );
}

function CardStatistics({
  title,
  iconBgColor,
  borderColor,
  icon,
  total,
}: {
  title: string;
  total: number;
  icon: React.ReactNode;
  iconBgColor: string;
  borderColor: string;
}) {
  return (
    <div className="col-12 col-sm-6 col-lg-3 ">
      <div
        className={`card rounded-4 overflow-hidden position-relative shadow p-3 mb-4 rounded-5  border ${borderColor}`}
      >
        <div className="card-body p-2">
          <div className="d-flex align-items-center justify-content-between mb-2">
            <div
              className={`rounded-circle ${iconBgColor} bg-opacity-10 p-3 d-flex align-items-center justify-content-center`}
            >
              {icon}
            </div>
            <div className="text-end">
              <h6 className="text-black mb-1 fw-normal">{title}</h6>
              <h3 className="fw-bold mb-0 text-black">
                {formatCurrency(total ?? 0)} MAD
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
